import { readAsList } from '@one-vision/json-api-parser';
import { apiClient } from 'core/api';
import { AppThunk } from 'core/redux';
import { getNextPage } from 'core/redux/reducers/helpers';
import UserGroupRules from 'core/redux/reducers/userGroupRules';
import UserGroups from 'core/redux/reducers/userGroups';
import RuleValues from 'core/redux/reducers/userGroupRuleValues';
import { ListReducerState } from 'core/redux/reducers/types';

export const fetchUserRuleValues =
  (options: Partial<ListReducerState> = {}, listId?: string): AppThunk =>
  async (dispatch, getState) => {
    const state = getState();
    const listState = RuleValues.selectors.selectList(state, listId || '');
    const nextPage = getNextPage(options.page, listState);

    const limit = options.perPage || listState.perPage;
    const offset = limit * (nextPage - 1);

    delete options.perPage;
    const apiResponse = await apiClient.getUserRuleValues({
      include: listState.include,
      search: listState.search,
      ...options,
      page: {
        limit,
        offset,
      },
    });

    const {
      meta: { page, defaultPage, ...meta },
      entities,
    } = readAsList(apiResponse.data);

    const { UserGroupRuleValue, UserGroup, UserGroupRule } = entities;

    if (UserGroupRuleValue) {
      dispatch(
        RuleValues.actions.batch([
          RuleValues.actions.updateList(
            {
              ...meta,
              ids: UserGroupRuleValue.map((e) => e.id),
              page: page ? page.offset / page.limit + 1 : nextPage,
              perPage: page ? +page.limit : listState.perPage,
              lastPage: Math.ceil(
                meta.totalCount / (page ? page.limit : listState.perPage),
              ),
            },
            listId,
          ),
          RuleValues.actions.upsertMany(UserGroupRuleValue),
        ]),
      );
    }

    if (UserGroup) {
      dispatch(UserGroups.actions.upsertMany(UserGroup));
    }
    if (UserGroupRule) {
      dispatch(UserGroupRules.actions.upsertMany(UserGroupRule));
    }
  };
